<template>
    <div class="planet_img row">
        <div class="images">
            <slot />
        </div>
    </div>
</template>